module.exports = __webpack_public_path__ + "img/CCV.72548aa4.svg";